import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';

@Component({
  selector: 'app-client-deactivation-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, CalendarModule],
  templateUrl: './client-deactivation-modal.component.html',
  styleUrl: './client-deactivation-modal.component.scss'
})
export class ClientDeactivationModalComponent implements OnChanges {
  @Input() isReactivation: boolean = false;
  @Input() isSaving: boolean = false;
  @Input() errorMessage: string = '';
  @Output() cancelEvent = new EventEmitter<void>();
  @Output() confirmEvent = new EventEmitter<Date | null>();

  endDate: Date | null = null;
  minDate: Date = new Date();

  constructor() {
    // Inicializar con la fecha de hoy
    this.endDate = new Date();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Reinicializar la fecha cuando se abre el modal (si no es reactivación)
    if (!this.isReactivation) {
      this.endDate = new Date();
    }
  }

  onCloseModal() {
    this.cancelEvent.emit();
    // Reinicializar para la próxima vez que se abra
    if (!this.isReactivation) {
      this.endDate = new Date();
    } else {
      this.endDate = null;
    }
  }

  onConfirm() {
    // La fecha se conserva: si el guardado falla, el modal sigue abierto y se puede reintentar.
    this.confirmEvent.emit(this.isReactivation ? null : this.endDate);
  }
}

